import ReactGA from "react-ga4";

export const createGAEventTracker = (category = "Category") => {
    return (action = "action", label = "label") => {
        ReactGA.event({
            category,
            action,
            label,
        });
    };
};
